import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';

import { take } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { LocationsDescriptionHelper } from '@core/locations-logic';
import { AssignedLocationsInfoComponent } from '@core/locations-ui';
import type { TooltipPosition } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-assigned-locations-info-container',
  template: `<rt-assigned-locations-info
    [locationNames]="locationNames"
    [showIcon]="showIcon()"
    [displayInline]="displayInline()"
    [tooltipPrefix]="tooltipPrefix()"
    [tooltipPosition]="tooltipPosition()"
    [isBadge]="isBadge()"
  />`,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AssignedLocationsInfoComponent],
})
export class AssignedLocationsInfoContainerComponent {
  private readonly locationsDescriptionHelper = inject(LocationsDescriptionHelper);

  public readonly locationIds = input.required<number[]>();
  public readonly companyId = input<number>();
  public readonly showIcon = input(false);
  public readonly displayInline = input(false);
  public readonly tooltipPrefix = input('');
  public readonly tooltipPosition = input<TooltipPosition>('below');
  public readonly isBadge = input(false);

  public locationNames: string[];

  public ngOnChanges(): void {
    this.locationsDescriptionHelper
      .getLocationNames$(this.locationIds(), this.companyId())
      .pipe(filterBoolean, take(1))
      .subscribe(locationNames => (this.locationNames = locationNames));
  }
}
